import React, { useState } from 'react';
import { Button } from 'antd';
import { Drawer, TextArea, Form } from '@common/components';
import { createMessage } from 'works/legacy/lib/message-helper';
import { useMutation } from '@common/hooks';
import { SubmittalPacketChangeRequestMutation } from '@applicant-flow/graphql';

export function SubmittalPacketChangeRequestDrawer({
  open,
  onClose,
  applicationId,
}: {
  open: boolean;
  onClose: () => void;
  applicationId?: string;
}) {
  const [note, setNote] = useState('');

  function onError() {
    createMessage(
      'error',
      'Failed to submit change request. Please try again.'
    );
  }

  const [submitChangeRequest, { loading }] = useMutation(
    SubmittalPacketChangeRequestMutation,
    {
      refetchQueries: [
        'StaffingRequestPageQuery',
        'StaffingRequestApplicationData',
      ],
      onCompleted: (response = {}) => {
        const { createOfferChangeRequest } = response;

        if (createOfferChangeRequest && !createOfferChangeRequest.errors) {
          createMessage('success', 'Change request has been submitted.');
        } else {
          onError();
        }

        onDrawerClose();
      },
      onError,
    }
  );

  function onDrawerClose() {
    onClose();
    setNote('');
  }

  function onSubmit() {
    submitChangeRequest({
      variables: {
        changeRequestableId: applicationId,
        changeRequestType: 'submittal_packet',
        input: {
          note,
        },
      },
    });
  }

  return (
    <Drawer
      open={open}
      title="Request Submittal Packet Changes"
      onClose={onDrawerClose}
      footer={
        <Button
          size="large"
          type="primary"
          disabled={!note}
          loading={loading}
          onClick={onSubmit}
        >
          Request
        </Button>
      }
    >
      <Form layout="vertical">
        <Form.Item label="Note to Supplier">
          <TextArea
            value={note}
            maxLength={500}
            onChange={(e) => setNote(e.target.value)}
          />
        </Form.Item>
      </Form>
    </Drawer>
  );
}
